import { atom } from "recoil";

export interface WebTestType {
  onboardingType?: string;
}

export const webTestTypeAtom = atom<WebTestType | undefined>({
  key: "WebTestType",
  default: undefined,
});
